import { render, staticRenderFns } from "./others.vue?vue&type=template&id=5206c44a&scoped=true"
import script from "./others.vue?vue&type=script&lang=js"
export * from "./others.vue?vue&type=script&lang=js"
import style0 from "./others.vue?vue&type=style&index=0&id=5206c44a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5206c44a",
  null
  
)

export default component.exports